/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {bulkAddCustomerSpecificReferenceableSyncEntity} from '../api'

export const useMutationBulkAddCustomerSpecificReferenceableSyncEntity = createReactQueryMutationHook('bulkAddCustomerSpecificReferenceableSyncEntity', bulkAddCustomerSpecificReferenceableSyncEntity)
